<template>
  <div>
    <h1 class="title">{{ $t('term.drillProgress') }}</h1>
    <h2 class="subtitle">{{ service.label }}</h2>

    <div class="mt-6">
      <ul class="is-flex is-flex-wrap-wrap custom-flex-container">
        <li
          v-for="(post, index) in posts"
          :key="post.postId"
          class="list-cell"
          :class="{ 'has-background-success': masteredPostIds.includes(post.postId) }"
        >
          <router-link
            :to="`/posts/${service.serviceId}/${post.slug}`"
            class="is-block is-size-5"
            :class="{ 'has-text-white': masteredPostIds.includes(post.postId) }"
          >
            {{ index + 1 }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Service, Post, User } from '@/api'
export default {
  data() {
    return {
      service: {},
      posts: [],
      masteredPostIds: [],
      pagerKey: null,
      listCount: 100,
    }
  },

  computed: {
    categorySlug() {
      return this.$route.params.categorySlug
    },

    hasNext() {
      return this.pagerKey != null
    },
  },

  async created() {
    this.setService()
    await this.setPosts()
    this.setPostsMastered()
  },

  methods: {
    async setService() {
      this.$store.dispatch('setLoading', true)
      try {
        const res = await Service.get(this.serviceId)
        this.$store.dispatch('setLoading', false)
        this.service = res
      } catch (err) {
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async setPosts(isLatest = false) {
      let params = {
        withCategory: 0,
        order: 'asc',
      }
      if (this.pagerKey != null) {
        params.pagerKey = JSON.stringify(this.pagerKey)
      }
      params.count = this.listCount

      if (this.categorySlug) {
        params.category = this.categorySlug
      } else if (this.tagLabel) {
        params.tag = this.tagLabel
      }

      this.$store.dispatch('setLoading', true)
      try {
        const res = await Post.get(this.serviceId, null, params)
        this.pagerKey = res.pagerKey
        let items = res.items
        if (isLatest) {
          items.reverse()
        }
        items.map((item) => {
          if (isLatest) {
            this.posts.unshift(item)
          } else {
            this.posts.push(item)
          }
        })
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },

    async setPostsMastered(isLatest = false) {
      let params = {
        count: 100,
        order: 'asc',
      }
      this.$store.dispatch('setLoading', true)
      try {
        const items = await User.getPostsMastered(this.serviceId, params, this.userToken)
        items.map((item) => {
          this.masteredPostIds.push(item.postId)
        })
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },
  },
}
</script>

<style scoped>
.custom-flex-container {
  border-left: 1px solid #e8e8e8;
}
.list-cell {
  flex: 0 0 100px; /* ここで要素の幅を設定します。この例では200px */
  height: 80px;
  text-align: center;
  vertical-align: middle;
  line-height: 80px;
  margin: -1px -1px 0;
  box-sizing: border-box; /* ボーダーのサイズを制御します */
  border-top: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}
</style>
